var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPOpenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99992 13.6666C3.31802 13.6666 0.333252 10.6818 0.333252 6.99992C0.333252 3.31802 3.31802 0.333252 6.99992 0.333252C10.6818 0.333252 13.6666 3.31802 13.6666 6.99992C13.6666 10.6818 10.6818 13.6666 6.99992 13.6666ZM6.99992 12.3333C9.94545 12.3333 12.3333 9.94545 12.3333 6.99992C12.3333 4.0544 9.94545 1.66659 6.99992 1.66659C4.0544 1.66659 1.66659 4.0544 1.66659 6.99992C1.66659 9.94545 4.0544 12.3333 6.99992 12.3333Z",
    fill: "#E255F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPOpenIcon);
export default __webpack_public_path__ + "static/media/p-open-icon.419f442b9fcb802e6ffcdfaf83179911.svg";
export { ForwardRef as ReactComponent };